// Facebook (Meta) Pixel helpers.
// The `fbq` global is loaded via the inline Pixel snippet in public/index.html.
// These helpers are safe no-ops if the SDK hasn't initialised yet (e.g. SSR, adblock).

const hasFbq = () =>
  typeof window !== 'undefined' && typeof window.fbq === 'function';

/** Track a standard Meta Pixel event (e.g. 'Purchase', 'Lead', 'PageView'). */
export function fbTrack(eventName, params = {}) {
  if (hasFbq()) {
    try { window.fbq('track', eventName, params); } catch {}
  }
}

/** Track a custom event — useful for funnel analysis not covered by standard events. */
export function fbTrackCustom(eventName, params = {}) {
  if (hasFbq()) {
    try { window.fbq('trackCustom', eventName, params); } catch {}
  }
}

/** Fire a PageView (SPA route change). */
export function fbPageView() {
  fbTrack('PageView');
}
